/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Error_LoadInputs */

const en_us2_profile_editors_error_load = /** @type {(inputs: Profile_Editors_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load this. Close it and try again.`)
};

const pt_br2_profile_editors_error_load = /** @type {(inputs: Profile_Editors_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para carregar. Feche e tente de novo.`)
};

const es_419_profile_editors_error_load = /** @type {(inputs: Profile_Editors_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar. Ciérralo e inténtalo de nuevo.`)
};

const pt_pt2_profile_editors_error_load = /** @type {(inputs: Profile_Editors_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar. Fecha e tenta outra vez.`)
};

const fr_fr2_profile_editors_error_load = /** @type {(inputs: Profile_Editors_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger. Ferme et réessaie.`)
};

const de_de2_profile_editors_error_load = /** @type {(inputs: Profile_Editors_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konnte nicht geladen werden. Schließ es und versuch es noch mal.`)
};

const it_it2_profile_editors_error_load = /** @type {(inputs: Profile_Editors_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare. Chiudi e riprova.`)
};

/**
* | output |
* | --- |
* | "Couldn't load this. Close it and try again." |
*
* @param {Profile_Editors_Error_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_error_load = /** @type {((inputs?: Profile_Editors_Error_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Error_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_error_load(inputs)
	if (locale === "es-419") return es_419_profile_editors_error_load(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_error_load(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_error_load(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_error_load(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_error_load(inputs)
	return en_us2_profile_editors_error_load(inputs)
});
export { profile_editors_error_load as "profile-editors.error_load" }